var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import CardReactFormContainer from 'card-react';
var CreditCardInput = /** @class */ (function (_super) {
    __extends(CreditCardInput, _super);
    function CreditCardInput(props) {
        var _this = _super.call(this, props) || this;
        _this.form = null;
        return _this;
    }
    CreditCardInput.prototype.getCard = function () {
        var _a, _b, _c, _d, _e;
        var card = {
            number: (_a = this.form) === null || _a === void 0 ? void 0 : _a.elements['CCnumber'].value,
            name: (_b = this.form) === null || _b === void 0 ? void 0 : _b.elements['CCname'].value,
            month: (_c = this.form) === null || _c === void 0 ? void 0 : _c.elements['CCexpiry'].value.split('/')[0].trim(),
            year: (_d = this.form) === null || _d === void 0 ? void 0 : _d.elements['CCexpiry'].value.split('/').pop().trim(),
            cvv: (_e = this.form) === null || _e === void 0 ? void 0 : _e.elements['CCcvc'].value,
        };
        return card;
    };
    CreditCardInput.prototype.valid = function () {
        var _a;
        try {
            if ((_a = this.form) === null || _a === void 0 ? void 0 : _a.elements['CCexpiry'].value.includes('/')) {
                var card = this.getCard();
                if (card.cvv != '' && card.cvv.length > 1
                    && card.month != '' && card.month.length > 0
                    && card.year != '' && card.year.length > 0
                    && card.number != '' && card.number.length > 5
                    && card.name != '' && card.name.length > 1) {
                    return true;
                }
            }
        }
        catch (error) {
        }
        return false;
    };
    CreditCardInput.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: 'CreditCardInput' },
            React.createElement(CardReactFormContainer, { container: "card-wrapper" // required
                , formInputsNames: {
                    number: 'CCnumber',
                    // optional — default "number"
                    expiry: 'CCexpiry',
                    // optional — default "expiry"
                    cvc: 'CCcvc',
                    // optional — default "cvc"
                    name: 'CCname' // optional - default "name"
                }, 
                // when the input is valid/invalid.
                classes: {
                    valid: 'valid-input',
                    invalid: 'invalid-input' // optional — default 'jp-card-invalid'
                } },
                React.createElement("form", { ref: function (ref) {
                        _this.form = ref;
                    } },
                    React.createElement("div", { className: "one-col" },
                        React.createElement("input", { className: 'cc-input', placeholder: "Full name", type: "text", name: "CCname" })),
                    React.createElement("div", { className: "one-col" },
                        React.createElement("input", { placeholder: "Card number", type: "text", name: "CCnumber" })),
                    React.createElement("div", { className: "two-col" },
                        React.createElement("input", { placeholder: "MM/YY", type: "text", name: "CCexpiry" }),
                        React.createElement("input", { placeholder: "CVC", type: "text", name: "CCcvc" })))),
            React.createElement("div", { id: "card-wrapper" })));
    };
    return CreditCardInput;
}(React.Component));
export default CreditCardInput;
//# sourceMappingURL=CreditCardInput.js.map